export const Info = [
    {
        title : "Movie Search Engine",
        description : "Using OMDb API for Movie related info, created this responsive webpage in reactjs.",
        image : "assets/images/project1.png",
        url : "https://naqiABC/Movie.git"
    },
    
    {
        title : "Quiz Game",
        description : "created this QUIZ GAME in reactjs.",
        image : "assets/images/naqi.jpg",
        url : "https://naqiABC/Quiz_App.git"
    },

    {
        title : "Expense Tracker",
        description : "This Expense Tracker was made to practice Reactjs and Material UI.",
        image : "assets/images/expense.png",
        url : "https://expensetracki.netlify.app/"
    }
]